import { IconType } from "@shared-features/enums/shared-enums.enum";

export class Icon {
  constructor(
    public name: string,
    public type = IconType.MaterialDesign,
    public position: string = 'left'
  ){}
}
